import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ImagePreView"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
const _hoisted_3 = { class: "imageUpload" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-image" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_image = _resolveComponent("n-image")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_p = _resolveComponent("n-p")!
  const _component_n_upload_dragger = _resolveComponent("n-upload-dragger")!
  const _component_n_upload = _resolveComponent("n-upload")!

  return (_ctx.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_n_image, { src: _ctx.ImagePath }, null, 8, ["src"]),
        _createVNode(_component_n_space, { class: "controlImage" }, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              onClick: _ctx.DeleteImage,
              tertiary: "",
              secondary: "",
              circle: "",
              type: "error"
            }, {
              icon: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_n_upload, {
        key: 1,
        "directory-dnd": "",
        "custom-request": _ctx.customRequest,
        accept: ".jpeg,.jpg,.png,image/jpeg"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_upload_dragger, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_n_text, { style: {"font-size":"16px"} }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Click or drag a file to this area to upload ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_n_p, {
                  depth: "3",
                  style: {"margin":"8px 0 0 0"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Strictly prohibit from uploading sensitive information. For example, your bank card PIN or your credit card expiry date. ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["custom-request"]))
}